import React from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "../../../i18n/i18n";
import styles from "./LanguageSelector.module.scss";

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  return (
    <div className={styles.wrapper}>
      {SUPPORTED_LANGUAGES.map(({ code, flag }) => (
        <button
          key={code}
          type="button"
          className={`${styles.langBtn} ${i18n.language === code ? styles.active : ""}`}
          onClick={() => i18n.changeLanguage(code)}
          aria-label={code.toUpperCase()}
        >
          <span className={styles.flag}>{flag}</span>
          <span className={styles.code}>{code.toUpperCase()}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
